"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listMonths = listMonths;
const datePart_1 = require("./datePart");
const lang_1 = require("./lang");
const padNumber_1 = require("./padNumber");
/**
 * Zwraca tablicę zawierającą listę miesięcy pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 * @param format format, domyślnie MMMM yyyy, czyli "styczeń 2019"
 */
function listMonths(startDate, endDate, format /* = 'MMMM yyyy'*/) {
    var _a;
    let m1 = 0;
    let y1 = 0;
    if (typeof startDate === 'string') {
        m1 = (0, datePart_1.datePart)(startDate, 'M');
        y1 = (0, datePart_1.datePart)(startDate, 'y');
    }
    else {
        m1 = startDate.getMonth() + 1;
        y1 = startDate.getFullYear();
    }
    let m2 = 0;
    let y2 = 0;
    if (typeof endDate === 'string') {
        m2 = (0, datePart_1.datePart)(endDate, 'M');
        y2 = (0, datePart_1.datePart)(endDate, 'y');
    }
    else {
        m2 = endDate.getMonth() + 1;
        y2 = endDate.getFullYear();
    }
    const currentLang = (_a = this === null || this === void 0 ? void 0 : this.lang) !== null && _a !== void 0 ? _a : lang_1.defaultLang.current;
    const result = [];
    if (m1 && y1 && m2 && y2) {
        m1--;
        m2--;
        let ys = ' ' + y1;
        let func;
        switch (format) {
            case 'MMMM yyyy':
                func = (m) => currentLang.months[m] + ys;
                break;
            case 'MMM yyyy':
                func = (m) => currentLang.monthsShort[m] + ys;
                break;
            case 'MM yyyy':
                func = (m) => (0, padNumber_1.padNumber)(m + 1) + ys;
                break;
            case 'M yyyy':
                func = (m) => m + 1 + ys;
                break;
            case 'MMMM':
                func = (m) => currentLang.months[m];
                break;
            case 'MMM':
                func = (m) => currentLang.monthsShort[m];
                break;
            case 'MM':
                func = (m) => (0, padNumber_1.padNumber)(m + 1);
                break;
            case 'M':
                func = (m) => (m + 1).toString();
                break;
            default:
                func = (m) => currentLang.months[m] + ys;
                break;
        }
        while ((m1 <= m2 && y1 === y2) || y1 < y2) {
            result.push(func(m1, y1));
            m1++;
            if (m1 > 11) {
                m1 = 0;
                y1++;
                ys = ' ' + y1;
            }
        }
    }
    return result;
}
//# sourceMappingURL=listMonths.js.map